export type AnalyzeFields = {
  marca?: string;
  modelo?: string;
  ano?: string;
  fipe?: string;
  danoSimulado?: string; // opcional para o backend aproveitar
};

// Compacta imagem mantendo máx. largura
export async function compressImage(file: File, maxWidth = 1600, quality = 0.78): Promise<File> {
  if (!file.type.startsWith("image/")) return file;

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const ratio = Math.min(1, maxWidth / img.width);
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      const ctx = canvas.getContext("2d")!;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => {
          if (!blob) return resolve(file);
          const newFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".jpg", { type: "image/jpeg" });
          resolve(newFile);
        },
        "image/jpeg",
        quality,
      );
    };
    img.onerror = () => resolve(file);
    img.src = URL.createObjectURL(file);
  });
}

export async function analyzePhotos(params: { files: File[]; fields?: AnalyzeFields }): Promise<any> {
  const { files, fields = {} } = params;
  if (!files || files.length === 0) {
    throw new Error("Adicione ao menos 1 foto.");
  }

  // Compressão paralela
  const compressed = await Promise.all(files.map((f) => compressImage(f)));

  const fd = new FormData();
  if (fields.marca) fd.append("marca", fields.marca);
  if (fields.modelo) fd.append("modelo", fields.modelo);
  if (fields.ano) fd.append("ano", fields.ano);
  if (fields.fipe) fd.append("fipe", fields.fipe);
  if (fields.danoSimulado) fd.append("danoSimulado", fields.danoSimulado);

  compressed.forEach((c) => fd.append("photos", c, c.name));

  const res = await fetch("/api/analyze", { method: "POST", body: fd });
  if (!res.ok) {
    const text = await res.text().catch(() => null);
    throw new Error(text || "Erro no servidor ao enviar imagens.");
  }
  return res.json();
}
